import { useApiClient } from '@m43/core';
import { QueueViewsResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';
import { Banner } from '@cad-arc';

export function UnitQueueErrorBanner() {
    const apiClient = useApiClient();
    const unitQueueViewsBootstrapQuery = useQuery({
        queryKey: ['unit-queue-views-bootstrap'],
        queryFn() {
            return apiClient.request<QueueViewsResource.BootstrapUnitQueueViews>({
                method: 'POST',
                url: 'queue_views/unit_queue_views/bootstrap/',
                data: {
                    agencyTypeGlobalAttrIds: [],
                    dispatchAreaIds: [],
                    queueColumnFilters: [],
                    isPinToPrimaryActive: true,
                    unitTypeAttrIds: [],
                    isCadUnitLevelDispositionsEnabled: false,
                },
            });
        },
        enabled: false,
    });

    return unitQueueViewsBootstrapQuery.isError ? (
        <Banner
            status="error"
            title="Unit Queues Out of Date"
            description="Data in Unit Queues is out of date. Click Re-Sync to bring them back up to date."
            style={{
                marginTop: 0,
            }}
            actions={[
                {
                    children: 'Re-Sync',
                    isLoading: unitQueueViewsBootstrapQuery.isLoading,
                    variant: 'solid',
                    onClick() {
                        unitQueueViewsBootstrapQuery.refetch();
                    },
                },
            ]}
        />
    ) : (
        <></>
    );
}
